export const styles = () => ({
  contentWrapper: { backgroundColor: '#e5f0ff', padding: 25 },
});
